import { normalizeArrayToEntity } from 'utils/helpers';

const migrations = {
  1: (state) => {
    return {
      ...state,
      auth: { ...state.auth, entities: null },
    };
  },
  2: (state) => {
    return {
      ...state,
      auth: { ...state.auth, entities: [] },
    };
  },
  3: (state) => {
    return {
      ...state,
      auth: {
        ...state.auth,
        entities: normalizeArrayToEntity(state.auth.entities),
        selectedEntityId: state.auth.selectedEntity.id,
      },
    };
  },
  4: (state) => {
    return state;
  },
};

export { migrations };
export default migrations;
